import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-border/70 bg-background py-12">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 md:flex-row md:items-end md:justify-between md:px-8">
      <div>
        <Link to="/" className="text-lg font-bold uppercase tracking-[0.12em] text-foreground">TruthForge AI</Link>
        <p className="mt-3 text-xs uppercase tracking-[0.14em] text-body">© 2024 TRUTHFORGE AI. THE INTELLIGENCE ARCHITECT. ALL RIGHTS RESERVED.</p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-3 text-xs uppercase tracking-[0.18em] text-body">
        <Link to="/insights" className="transition hover:text-foreground">Insights</Link>
        <Link to="/whitepaper" className="transition hover:text-foreground">Whitepaper</Link>
        <Link to="/privacy-policy" className="transition hover:text-foreground">Privacy Policy</Link>
        <Link to="/terms-and-conditions" className="transition hover:text-foreground">Terms of Service</Link>
      </div>
    </div>
  </footer>
);
